<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>SAHA KAYIT EKRANI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#">SAHA KAYIT EKRANI</a></li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">SAHA KAYIT EKRANI</h3>

            <div class="tile-body">
              <form>
                <div class="form-group">
                  <label class="control-label">Saha Adı</label>
                  <input
                    v-model="sahaname"
                    class="form-control"
                    type="text"
                    placeholder="ANTEP ISLAHİYE YEO"
                  />
                </div>
                <div id="app">
                  <label class="control-label">Makina Seçiniz</label>
                  <select class="form-control" @change="changemakina($event)">
                    <option value="" selected disabled>MAKİNA SEÇİNİZ</option>
                    <option
                      v-for="machine in machines"
                      :value="machine.id"
                      :key="machine.id"
                      >{{
                        machine.makina_code + " " + machine.makina_name
                      }}</option
                    >
                  </select>
                </div>
                <div id="app">
                  <label class="control-label">1.Operatörü Seçiniz</label>
                  <select class="form-control" @change="changeoprone($event)">
                    <option value="" selected disabled>1.OPERATÖR</option>
                    <option
                      v-for="operator in operators"
                      :value="operator.id"
                      :key="operator.id"
                      >{{ operator.name + " " + operator.surname }}</option
                    >
                  </select>
                </div>
                <div id="app">
                  <label class="control-label">2.Operatörü Seçiniz</label>
                  <select class="form-control" @change="changeoprtwo($event)">
                    <option value="" selected disabled>2.OPERATÖR</option>
                    <option
                      v-for="operator in operators"
                      :value="operator.id"
                      :key="operator.id"
                      >{{ operator.name + " " + operator.surname }}</option
                    >
                  </select>
                </div>
                <div id="app">
                  <label class="control-label"
                    >1.Yardımcı Personeli Seçiniz</label
                  >
                  <select class="form-control" @change="changeyrdone($event)">
                    <option value="" selected disabled
                      >1.YARDIMCI PERSONEL</option
                    >
                    <option
                      v-for="yardimci in yardimcis"
                      :value="yardimci.id"
                      :key="yardimci.id"
                      >{{ yardimci.name + " " + yardimci.surname }}</option
                    >
                  </select>
                </div>
                <div id="app">
                  <label class="control-label"
                    >2.Yardımcı Personeli Seçiniz</label
                  >
                  <select class="form-control" @change="changeyrdtwo($event)">
                    <option value="" selected disabled
                      >2.YARDIMCI PERSONEL</option
                    >
                    <option
                      v-for="yardimci in yardimcis"
                      :value="yardimci.id"
                      :key="yardimci.id"
                      >{{ yardimci.name + " " + yardimci.surname }}</option
                    >
                  </select>
                </div>
              </form>
            </div>

            <div class="tile-footer">
              <button @click="sendData()" class="btn btn-primary" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>Kaydet
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      sahaname: "",
      makinaId: "",
      oprone: "",
      oprtwo: "",
      yrdone: "",
      yrdtwo: "",
      machines: [],
      operators: [],
      yardimcis: [],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/");
    }
    var url = store.state.base_url + "AslanSahalar/getAllMakinaFilter.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.machines = response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
    var url = store.state.base_url + "AslanSahalar/getAllOperator.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.operators = response.data.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
    var url = store.state.base_url + "AslanSahalar/getAllYardimci.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.yardimcis = response.data.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  methods: {
    changeoprone(event) {
      this.oprone = event.target.value;
    },
    changeoprtwo(event) {
      this.oprtwo = event.target.value;
    },
    changeyrdone(event) {
      this.yrdone = event.target.value;
    },
    changeyrdtwo(event) {
      this.yrdtwo = event.target.value;
    },
    changemakina(event) {
      this.makinaId = event.target.value;
    },
    reload: function() {
      location.reload();
    },
    sendData: function() {
      console.log(this.oprone)
      if (this.oprone == "") {
        this.$swal({
          text: "En az 1 operatör seçiniz!",
          icon: "error",
          closeOnClickOutside: false,
        });
      }else if(this.sahaname == ""){
        this.$swal({
          text: "Saha adı giriniz!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else {
        var url = store.state.base_url + "AslanSahalar/updateSaha.php?key=123";
        var datas = {
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          oprone: this.oprone,
          oprtwo: this.oprtwo,
          yrdone: this.yrdone,
          yrdtwo: this.yrdtwo,
          sahaname: this.sahaname,
          makinaId: this.makinaId,
        };

        axios
          .post(url, JSON.stringify(datas))
          .then((response) => {
            if (response.data == true) {
              this.$swal({
                text: "Kayıt İşleminiz Başarıyla Gerçekleştirildi!",
                icon: "success",
                closeOnClickOutside: true,
              });
              setTimeout(function() {location.reload()},1250);

            } else {
              this.$swal({
                text: "Hata Oluştu!",
                icon: "error",
                closeOnClickOutside: false,
              });
            }

            ////conso.log(response);
          })
          .catch((error) => {
            //conso.log(error.response);
          });
      }
    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UploadFile.vue